import React from "react";
import { BrowserRouter as Router, Routes, Route} from "react-router-dom";
import Header from "./components/Header/Header";
import Cars from "./components/Cars/Cars";
import Rates from "./components/Rates/Rates";
import Contact from "./components/Contact/Contact";
import Home from "./components/Home/Home";
import Services from "./components/Services/Services";
import Informations from "./components/Informations/Informations";
import Links from "./components/Links/Links";
import Footer from "./components/Footer/Footer";
import NotFound from "./components/NotFound";
import ReservationForm from "./components/Reservation/ReservationForm";
import ResponseBank from "./components/ResponseBank/ResponseBank";
import LegalNotice from "./components/LegalNotice/LegalNotice";
import TermsOfService from "./components/LegalNotice/TermsOfService";
import PrivacyPolicy from "./components/LegalNotice/PrivacyPolicy";
import LogDebug from "./utils/LogDebug";
import RedirectWithoutPhp from "./utils/RedirectWithoutPhp";
// import logErrorToServer from "./utils/logErrorToServer";
// const version = new Date().getTime(); // Génère un timestamp unique

function App() {

    // logErrorToServer("Connexion à Apps.js");

  return (
    <Router>


      {/* En-tête visible sur toutes les pages */}
      <Header />

      {/* Contenu principal avec Routes */}
      <div className="main-content">
        <Routes>
          {/* Page d'accueil */}
          <Route path="/" element={<Home /> } />

          {/* Page des voitures */}
          <Route path="/cars" element={<Cars />} />

          <Route path="/rates" element={<Rates />} />
          <Route path="/reservation" element={<ReservationForm />} />
          <Route path="/booking" element={<ReservationForm />} />
          <Route path="/response_bank_ok_ko.php" element={<ResponseBank />} />
          <Route path="/response_bank_ok_ko" element={<ResponseBank />} />

          {/* Page des services */}
          <Route path="/services" element={<Services />} />
          <Route path="/info" element={<Informations />} />
          <Route path="/informations" element={<Informations />} />
          <Route path="/links" element={<Links />} />

          {/* Page de contact */}
          <Route path="/contact" element={<Contact />} />
          <Route path="/legal-notice" element={<LegalNotice />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />


          {/* Redirection de /response_bank_ok_ko.php vers /response_bank_ok_ko */}
          <Route path="/response_bank_ok_ko.php" element={<RedirectWithoutPhp />} />
          

          {/* Page 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>

        {/* Activer ou désactiver les logs */}
        {process.env.NODE_ENV === "development" && <LogDebug isActive={true} />}
      </div>

      {/* Pied de page visible sur toutes les pages */}
      <Footer />
    </Router>
  );
}

export default App;